import { FormattedMessage } from 'react-intl'
import { FilterNumber } from '../types'
import { FilterTypes } from './Number/numbers'
import { MenuItem, SelectField } from '@carto/meridian-ds/components'

function NumberFilterTypeSelect({
  type,
  disabled,
  onChange
}: {
  type: FilterNumber
  disabled?: boolean
  onChange: (value: FilterNumber) => void
}) {
  return (
    <SelectField
      displayEmpty
      disabled={disabled}
      name="analysis-column.number.label"
      label={<FormattedMessage id="analysis.columnValue.numberFilter.label" />}
      labelId={`analysis-column.number.label`}
      value={type}
      onChange={(e) => onChange(e.target.value as FilterNumber)}
    >
      {Object.keys(FilterTypes).map((type) => (
        <MenuItem key={type} value={type}>
          {FilterTypes[type].label}
        </MenuItem>
      ))}
    </SelectField>
  )
}

export default NumberFilterTypeSelect
